import React, {Suspense} from 'react';
import {Route, Switch} from 'react-router-dom';
import {LoadingScreen} from 'components/loading-screen';
import {makeRoute} from './routes';

const Pages = React.lazy(() => import('./screens/pages'));
const Create = React.lazy(() => import('./screens/new'));
const Edit = React.lazy(() => import('./screens/edit'));

export function Router() {
    return (
        <Suspense fallback={<LoadingScreen/>}>
            <Switch>
                <Route
                    exact={true}
                    path={makeRoute.home()}
                    component={Pages}
                />
                <Route
                    exact={true}
                    path={makeRoute.create()}
                    component={Create}
                />
                <Route
                    exact={true}
                    path={makeRoute.edit(':id')}
                    component={Edit}
                />
            </Switch>
        </Suspense>
    );
}